import requestSender from "@/api/base/requestSender";

const UrlPrefix = "cascading/";

export default function(axiosInstance) {
  return {

    elementsSearch(payload, options) {
      return requestSender("get", UrlPrefix + "element/search", payload, options);
    },
    elementsGetByParentId(payload, options) {
      return requestSender("get", UrlPrefix + "element/get-by-parent-id", payload, options);
    },
    elementsGetTreeFromElementToRoot(payload, options) {
      return requestSender("get", UrlPrefix + "element/get-tree-from-element-to-root", payload, options);
    },
    elementsGetByCardId(payload, options) {
      return requestSender("get", UrlPrefix + "element/get-by-card-id", payload, options);
    },

    elementCreate(payload, options) {
      return requestSender("post", UrlPrefix + "element/create", payload, options);
    },
    elementUpdate(payload, options) {
      return requestSender("post", UrlPrefix + "element/update", payload, options);
    },
    elementUpdateParentLink(payload, options) {
      return requestSender("post", UrlPrefix + "element/update-parent-link", payload, options);
    },
    elementUnlink(payload, options) {
      return requestSender("post", UrlPrefix + "element/unlink", payload, options);
    },
    elementDelete(payload, options) {
      return requestSender("post", UrlPrefix + "element/delete", payload, options);
    },
    elementDoDragAndDropAction(payload, options) {
      return requestSender("post", UrlPrefix + "element/do-drag-and-drop-action", payload, options);
    },
    elementAssignToCard(payload, options) {
      return requestSender("post", UrlPrefix + "element/assign-to-card", payload, options);
    },
    elementRunAutoCascading(payload, options) {
      return requestSender("post", UrlPrefix + "element/run-auto-cascading", payload, options);
    },


    getQualityScaleTemplates(payload, options) {
      return requestSender("get", UrlPrefix + "scale-quality-templates/search", payload, options);
    },
    createQualityScaleTemplate(payload, options) {
      return requestSender("post", UrlPrefix + "scale-quality-templates/create", payload, options);
    },
    updateQualityScaleTemplate(payload, options) {
      return requestSender("post", UrlPrefix + "scale-quality-templates/update", payload, options);
    },
    deleteQualityScaleTemplate(payload, options) {
      return requestSender("post", UrlPrefix + "scale-quality-templates/delete", payload, options);
    },

    createQualityScaleTemplateScope(payload, options) {
      return requestSender("post", UrlPrefix + "scale-quality-templates/create-scope", payload, options);
    },
    updateQualityScaleTemplateScope(payload, options) {
      return requestSender("post", UrlPrefix + "scale-quality-templates/update-scope", payload, options);
    },
    deleteQualityScaleTemplateScope(payload, options) {
      return requestSender("post", UrlPrefix + "scale-quality-templates/delete-scope", payload, options);
    },


    getPerformanceFormulas(payload, options) {
      return requestSender("get", UrlPrefix + "performance-formula/search", payload, options);
    },


    getCardScaleTemplates(payload, options) {
      return requestSender("get", UrlPrefix + "card-scale-templates/search", payload, options);
    },
    createCardScaleTemplate(payload, options) {
      return requestSender("post", UrlPrefix + "card-scale-templates/create", payload, options);
    },
    updateCardScaleTemplate(payload, options) {
      return requestSender("post", UrlPrefix + "card-scale-templates/update", payload, options);
    },
    deleteCardScaleTemplate(payload, options) {
      return requestSender("post", UrlPrefix + "card-scale-templates/delete", payload, options);
    },

    createCardScaleTemplateScope(payload, options) {
      return requestSender("post", UrlPrefix + "card-scale-templates/create-scope", payload, options);
    },
    updateCardScaleTemplateScope(payload, options) {
      return requestSender("post", UrlPrefix + "card-scale-templates/update-scope", payload, options);
    },
    deleteCardScaleTemplateScope(payload, options) {
      return requestSender("post", UrlPrefix + "card-scale-templates/delete-scope", payload, options);
    },



    getPermissionsList(payload, options) {
      return requestSender("get", UrlPrefix + "permissions-profile/get-permissions-list", payload, options);
    },
    getPermissionsProfiles(payload, options) {
      return requestSender("get", UrlPrefix + "permissions-profile/get-profiles", payload, options);
    },
    createPermissionsProfile(payload, options) {
      return requestSender("post", UrlPrefix + "permissions-profile/create", payload, options);
    },
    updatePermissionsProfile(payload, options) {
      return requestSender("post", UrlPrefix + "permissions-profile/update", payload, options);
    },
    updatePermissionValue(payload, options) {
      return requestSender("post", UrlPrefix + "permissions-profile/update-permission-value", payload, options);
    },
    deletePermissionsProfile(payload, options) {
      return requestSender("post", UrlPrefix + "permissions-profile/delete", payload, options);
    },


  };
}